import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { base64ToBlob } from '@core/util/string';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Api } from '../api.service';

export interface CloudConvertDownloadResponse {
	result: string;
	fileType: string;
}

@Injectable({
	providedIn: 'root',
})
/**
 * Wrapper for the C# CloudConvertController.
 */
export class CloudConvertApiService extends Api {
	constructor(private http: HttpClient) {
		super(http);
	}

	/**
	 * Downloads the file with the specified taskId from CloudConvert.
	 * @param taskId - The TaskId provided by CloudConvert.
	 * @returns An Observable that emits a Blob.
	 */
	download(taskId: string): Observable<Blob> {
		const url = `${environment.api.baseUrl}/cloud-convert/download`;

		return this.http.post<CloudConvertDownloadResponse>(url, { taskId }).pipe(
			take(1),
			map((results) => base64ToBlob(results.result, '')),
		);
	}
}
